import React from 'react';

const SidebarComponent = (menuItems) => {
  //console.log('menuItems sidebar', menuItems)
  return (
    <>

      <amp-sidebar id="sidebar-left" class="sample-sidebar" layout="nodisplay" side="left" >
        
        {/* <button on="tap:sidebar-left.close">Close sidebar</button> */}
        <span
          role="button"
          tabIndex={0}
          className="close-icon"
          on="tap:sidebar-left.close"
          aria-label="Close sidebar"
          style={{ fontSize: '24px' }}
        >
          &#x2715; {/* Unicode for the close icon (X) */}
        </span>
        <nav toolbar="(min-width:784px)" toolbar-target="target-element-left">
          <ul>
            {/* {menuItems?.menuItems?.map((val,index) => {return <li>{val.name}</li>} )} */}
            {menuItems.menuItems.map((menuItem, index) => (
              <a key={`menu-item-${index}`} href={menuItem.path} target="_self">
                {menuItem.name}
              </a>
            ))}

          </ul>
        </nav>

      </amp-sidebar>
      <span
        role="button"
        tabIndex={0}
        className="menu-icon"
        on="tap:sidebar-left.toggle"
        aria-label="Toggle sidebar"
        style={{ fontSize: '24px' }}
      >
        &#9776; {/* Unicode for the hamburger menu icon */}
      </span>
      <div id="target-element-left" className='hideAmpThemeTwo'></div>
    </>
  );
};

export default SidebarComponent;
